/* saturn-composer-core.js — GENERATED from services/composer/core (commit d36eb49).
 * Do not edit. Rebuild with storefront/tools/build-composer-core.sh.
 * Global: window.SaturnComposerCore — measure, splice, per-slug case check,
 * customer wording and the proof payload, identical to the server's re-check. */
"use strict";
var SaturnComposerCore = (() => {
  var __defProp = Object.defineProperty, __defProps = Object.defineProperties, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropDescs = Object.getOwnPropertyDescriptors, __getOwnPropNames = Object.getOwnPropertyNames, __getOwnPropSymbols = Object.getOwnPropertySymbols;
  var __hasOwnProp = Object.prototype.hasOwnProperty, __propIsEnum = Object.prototype.propertyIsEnumerable;
  var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: !0, configurable: !0, writable: !0, value }) : obj[key] = value, __spreadValues = (a, b) => {
    for (var prop in b || (b = {}))
      __hasOwnProp.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
      for (var prop of __getOwnPropSymbols(b))
        __propIsEnum.call(b, prop) && __defNormalProp(a, prop, b[prop]);
    return a;
  }, __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: !0 });
  }, __copyProps = (to, from, except, desc) => {
    if (from && typeof from == "object" || typeof from == "function")
      for (let key of __getOwnPropNames(from))
        !__hasOwnProp.call(to, key) && key !== except && __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: !0 }), mod);

  // services/composer/core/browser.ts
  var browser_exports = {};
  __export(browser_exports, {
    BOTTOM_MARGIN_IN: () => BOTTOM_MARGIN_IN,
    CENTER_BOX_MAX_ROW_PT: () => CENTER_BOX_MAX_ROW_PT,
    CENTER_BOX_ROWS: () => CENTER_BOX_ROWS,
    LEAD_PT: () => LEAD_PT,
    MAX_SLUGS_PER_LINE: () => MAX_SLUGS_PER_LINE,
    PX_PER_PICA: () => PX_PER_PICA,
    PX_PER_PT: () => PX_PER_PT,
    bandGeometry: () => bandGeometry,
    buildProofPayload: () => buildProofPayload,
    canvasMeasurer: () => canvasMeasurer,
    cardDims: () => cardDims,
    cardLineMeasurePica: () => cardLineMeasurePica,
    centerBoxOffsetPt: () => centerBoxOffsetPt,
    centerOffset: () => centerOffset,
    centerOffsetPt: () => centerOffsetPt,
    composeLimits: () => composeLimits,
    compositionKey: () => compositionKey,
    describeFit: () => describeFit,
    describeInventoryIssue: () => describeInventoryIssue,
    describeMeasureIssue: () => describeMeasureIssue,
    emulatorRowMetrics: () => emulatorRowMetrics,
    emulatorScale: () => emulatorScale,
    emulatorTransform: () => emulatorTransform,
    faceLimitPica: () => faceLimitPica,
    fitOf: () => fitOf,
    fontFamilyCss: () => fontFamilyCss,
    hasLineSpace: () => hasLineSpace,
    inchesLabel: () => inchesLabel,
    leadPt: () => leadPt,
    leadsBetween: () => leadsBetween,
    lineCharCap: () => lineCharCap,
    lineHeight: () => lineHeight,
    measureFontSpec: () => measureFontSpec,
    menuFaces: () => menuFaces,
    menuSizes: () => menuSizes,
    parseCatalog: () => parseCatalog,
    placementOption: () => placementOption,
    rowHeights: () => rowHeights,
    rowPitchPt: () => rowPitchPt,
    sizePt: () => sizePt,
    spaceEm: () => spaceEm,
    spaceLeads: () => spaceLeads,
    spacePt: () => spacePt,
    spliceLine: () => spliceLine,
    statusTitle: () => statusTitle,
    trimTrailingEmpty: () => trimTrailingEmpty,
    typeFit: () => typeFit,
    validateComposition: () => validateComposition
  });

  // services/composer/core/catalog.ts
  var PX_PER_PT = 1.3333333333333333, PX_PER_PICA = 12 * PX_PER_PT, DEFAULT_LINE_MEASURE_PICA = 22.5, DEFAULT_MAX_LINES = 4, DEFAULT_PLACEMENT = "twoThirds", DEFAULT_DIMS = { portrait: [5, 7], landscape: [7, 5] }, FALLBACK_INK = { hex: "#C8102E", name: "PMS 186" }, FALLBACK_PLACEMENTS = {
    twoThirds: { verticalCenterRatio: 0.3333, anchor: "baseline" },
    center: { verticalCenterRatio: 0.5, anchor: "center" }
  }, FLAT_PLACEMENTS = {
    top: { verticalCenterRatio: 0.2, anchor: "baseline" }
  }, SAFE_FONT_FAMILY_RE = /^[A-Za-z0-9 .-]{1,64}$/, SAFE_FONT_FILE_RE = /^[A-Za-z0-9._-]{1,96}\.woff2$/, CatalogError = class extends Error {
    constructor(path, message) {
      super(`catalog ${path}: ${message}`);
      this.path = path;
      this.name = "CatalogError";
    }
  };
  function isRecord(v) {
    return typeof v == "object" && v !== null && !Array.isArray(v);
  }
  function num(v, path, fallback) {
    if (typeof v == "number" && Number.isFinite(v)) return v;
    if (v === void 0 && fallback !== void 0) return fallback;
    throw new CatalogError(path, "expected a finite number");
  }
  function str(v, path, fallback) {
    if (typeof v == "string" && v.length > 0) return v;
    if (v === void 0 && fallback !== void 0) return fallback;
    throw new CatalogError(path, "expected a non-empty string");
  }
  function parseWebFont(v, path = "webFont") {
    if (!isRecord(v)) throw new CatalogError(path, "expected an object");
    let family = str(v.family, `${path}.family`);
    if (!SAFE_FONT_FAMILY_RE.test(family)) throw new CatalogError(`${path}.family`, "unsafe family name");
    let rawWeight = num(v.weight, `${path}.weight`, 400), weight = rawWeight >= 1 && rawWeight <= 1e3 ? Math.round(rawWeight) : 400, style = v.style === "italic" ? "italic" : "normal", out = { family, weight, style };
    if (v.file !== void 0) {
      let file = str(v.file, `${path}.file`);
      if (!SAFE_FONT_FILE_RE.test(file)) throw new CatalogError(`${path}.file`, "unsafe file name");
      out.file = file;
    }
    return out;
  }
  function parseSize(v, path) {
    if (!isRecord(v)) throw new CatalogError(path, "expected a size object");
    let maxCharsPerLine = num(v.maxCharsPerLine, `${path}.maxCharsPerLine`, 0);
    if (!isRecord(v.inventory)) throw new CatalogError(`${path}.inventory`, "expected an inventory map");
    let inventory = {};
    for (let [ch, count] of Object.entries(v.inventory)) {
      let n = num(count, `${path}.inventory[${JSON.stringify(ch)}]`);
      inventory[ch] = Math.max(0, Math.floor(n));
    }
    let out = { maxCharsPerLine, inventory };
    return v.menuExcluded === !0 && (out.menuExcluded = !0), out;
  }
  function parseFace(v, path) {
    if (!isRecord(v)) throw new CatalogError(path, "expected a face object");
    let webFont = v.webFont === void 0 ? void 0 : parseWebFont(v.webFont, `${path}.webFont`);
    if (!isRecord(v.sizes) || Object.keys(v.sizes).length === 0)
      throw new CatalogError(`${path}.sizes`, "expected at least one size");
    let sizes = {};
    for (let [label, entry] of Object.entries(v.sizes)) {
      if (!/^\d{1,3}pt$/.test(label)) throw new CatalogError(`${path}.sizes`, `bad size label ${JSON.stringify(label)}`);
      sizes[label] = parseSize(entry, `${path}.sizes[${label}]`);
    }
    let out = { sizes };
    return webFont && (out.webFont = webFont), v.lineCapacityPica !== void 0 && (out.lineCapacityPica = num(v.lineCapacityPica, `${path}.lineCapacityPica`)), v.menuExcluded === !0 && (out.menuExcluded = !0), out;
  }
  function parsePlacement(v, path) {
    if (!isRecord(v)) throw new CatalogError(path, "expected a placement option");
    return {
      verticalCenterRatio: num(v.verticalCenterRatio, `${path}.verticalCenterRatio`),
      anchor: v.anchor === "center" ? "center" : "baseline"
    };
  }
  function parseCatalog(raw) {
    if (!isRecord(raw)) throw new CatalogError("$", "expected an object");
    let catalogVersion = str(raw.catalogVersion, "catalogVersion"), maxLines = Math.max(1, Math.floor(num(raw.maxLines, "maxLines", DEFAULT_MAX_LINES))), maxLineMeasurePica = num(raw.maxLineMeasurePica, "maxLineMeasurePica", DEFAULT_LINE_MEASURE_PICA), minMenuPointSize = num(raw.minMenuPointSize, "minMenuPointSize", 0), cardDimensionsIn = __spreadValues({}, DEFAULT_DIMS);
    if (raw.cardDimensionsIn !== void 0) {
      if (!isRecord(raw.cardDimensionsIn)) throw new CatalogError("cardDimensionsIn", "expected an object");
      for (let f of ["portrait", "landscape"]) {
        let d = raw.cardDimensionsIn[f];
        if (d !== void 0) {
          if (!Array.isArray(d) || d.length !== 2) throw new CatalogError(`cardDimensionsIn.${f}`, "expected [w, h]");
          cardDimensionsIn[f] = [num(d[0], `cardDimensionsIn.${f}[0]`), num(d[1], `cardDimensionsIn.${f}[1]`)];
        }
      }
    }
    let cardLineMeasurePica2;
    if (raw.cardLineMeasurePica !== void 0) {
      if (!isRecord(raw.cardLineMeasurePica)) throw new CatalogError("cardLineMeasurePica", "expected an object");
      cardLineMeasurePica2 = {
        portrait: num(raw.cardLineMeasurePica.portrait, "cardLineMeasurePica.portrait"),
        landscape: num(raw.cardLineMeasurePica.landscape, "cardLineMeasurePica.landscape")
      };
    }
    let options = {}, placementDefault = DEFAULT_PLACEMENT;
    if (raw.messagePlacement !== void 0) {
      if (!isRecord(raw.messagePlacement)) throw new CatalogError("messagePlacement", "expected an object");
      if (placementDefault = str(raw.messagePlacement.default, "messagePlacement.default", DEFAULT_PLACEMENT), raw.messagePlacement.options !== void 0) {
        if (!isRecord(raw.messagePlacement.options)) throw new CatalogError("messagePlacement.options", "expected an object");
        for (let [key, opt] of Object.entries(raw.messagePlacement.options))
          options[key] = parsePlacement(opt, `messagePlacement.options.${key}`);
      }
    }
    let ink = { hex: FALLBACK_INK.hex, name: FALLBACK_INK.name };
    if (raw.ink !== void 0) {
      if (!isRecord(raw.ink)) throw new CatalogError("ink", "expected an object");
      let hex = str(raw.ink.hex, "ink.hex", FALLBACK_INK.hex);
      if (!/^#[0-9A-Fa-f]{6}$/.test(hex)) throw new CatalogError("ink.hex", "expected #rrggbb");
      ink = { hex, name: str(raw.ink.name, "ink.name", FALLBACK_INK.name) }, typeof raw.ink.pms == "string" && (ink.pms = raw.ink.pms);
    }
    if (!isRecord(raw.faces) || Object.keys(raw.faces).length === 0) throw new CatalogError("faces", "expected at least one face");
    let faces = {};
    for (let [name, face] of Object.entries(raw.faces)) {
      if (!SAFE_FONT_FAMILY_RE.test(name)) throw new CatalogError("faces", `unsafe face name ${JSON.stringify(name)}`);
      faces[name] = parseFace(face, `faces[${JSON.stringify(name)}]`);
    }
    return __spreadProps(__spreadValues({
      catalogVersion,
      maxLines,
      maxLineMeasurePica
    }, cardLineMeasurePica2 ? { cardLineMeasurePica: cardLineMeasurePica2 } : {}), {
      minMenuPointSize,
      cardDimensionsIn,
      messagePlacement: { default: placementDefault, options },
      ink,
      faces
    });
  }
  function sizePt(size) {
    return parseInt(size, 10);
  }
  function faceLimitPica(catalog, face) {
    let f = catalog.faces[face];
    return Math.min((f == null ? void 0 : f.lineCapacityPica) || DEFAULT_LINE_MEASURE_PICA, catalog.maxLineMeasurePica || DEFAULT_LINE_MEASURE_PICA);
  }
  function menuSizes(catalog, face) {
    let f = catalog.faces[face];
    if (!f) return [];
    let floor = catalog.minMenuPointSize || 0;
    return Object.keys(f.sizes).filter((s) => sizePt(s) >= floor && !f.sizes[s].menuExcluded).sort((a, b) => sizePt(a) - sizePt(b));
  }
  function menuFaces(catalog) {
    return Object.keys(catalog.faces).filter((f) => {
      let face = catalog.faces[f];
      return !!face.webFont && !face.menuExcluded && menuSizes(catalog, f).length > 0;
    });
  }
  function cardDims(catalog, format) {
    var _a;
    return (_a = catalog.cardDimensionsIn[format]) != null ? _a : DEFAULT_DIMS[format];
  }
  function placementOption(catalog, placement) {
    var _a, _b, _c;
    return (_c = (_b = (_a = catalog.messagePlacement.options[placement]) != null ? _a : FLAT_PLACEMENTS[placement]) != null ? _b : FALLBACK_PLACEMENTS[placement]) != null ? _c : FALLBACK_PLACEMENTS[DEFAULT_PLACEMENT];
  }
  function placementKnown(catalog, placement, flat) {
    return !!catalog.messagePlacement.options[placement] || flat && !!FLAT_PLACEMENTS[placement];
  }
  function fontShorthand(webFont, px, family = `"${webFont.family}"`) {
    return `${webFont.style === "italic" ? "italic " : ""}${webFont.weight} ${px}px ${family}`;
  }
  function measureFontSpec(webFont, size) {
    return fontShorthand(webFont, sizePt(size) * PX_PER_PT);
  }
  function fontFamilyCss(webFont) {
    return `"${webFont.family}", serif`;
  }

  // services/composer/core/measure.ts
  function measureLine(text, font, limitPica, measurer) {
    let limitPx = limitPica * PX_PER_PICA, widthPx = measurer.widthPx(text, font), overFromIndex = -1;
    if (widthPx > limitPx) {
      for (let i = 1; i <= text.length; i++)
        if (measurer.widthPx(text.slice(0, i), font) > limitPx) {
          overFromIndex = i - 1;
          break;
        }
    }
    return { widthPica: widthPx / PX_PER_PICA, limitPica, over: widthPx > limitPx, overFromIndex };
  }
  function canvasMeasurer(ctx) {
    return {
      widthPx(text, font) {
        return ctx.font = font, ctx.measureText(text).width;
      }
    };
  }

  // services/composer/core/geometry.ts
  var LUDLOW_SLUG_BODY_PT = 6, LUDLOW_FULL_SPACE_PT = 12, LUDLOW_HALF_SPACE_PT = 6, STICK_PT = 6;
  var LEAD_PT = STICK_PT;
  function leadsBetween(_pointSize) {
    return LUDLOW_SLUG_BODY_PT / LEAD_PT;
  }
  function leadPt(_pointSize) {
    return LUDLOW_SLUG_BODY_PT;
  }
  function rowPitchPt(pointSize) {
    return pointSize + leadPt(pointSize);
  }
  function lineHeight(pointSize) {
    return rowPitchPt(pointSize) / pointSize;
  }
  function spaceLeads(pointSize, half = !1) {
    return spacePt(pointSize, half) / LEAD_PT;
  }
  function spacePt(_pointSize, half = !1) {
    return half ? LUDLOW_HALF_SPACE_PT : LUDLOW_FULL_SPACE_PT;
  }
  function spaceEm(pointSize, half = !1) {
    return spacePt(pointSize, half) / pointSize;
  }
  function bandGeometry(dims, limitPica, placement) {
    let widthIn = limitPica / 6;
    return { topRatio: placement.verticalCenterRatio, widthIn, widthRatio: widthIn / dims[0], anchor: placement.anchor };
  }
  function emulatorScale(cardClientWidthPx, dims) {
    return cardClientWidthPx ? cardClientWidthPx / (dims[0] * 96) : 1;
  }
  function emulatorRowMetrics(pointSize, scale = 1) {
    let px = pointSize * PX_PER_PT * scale;
    return { px, rowH: Math.ceil(px * lineHeight(pointSize)) };
  }
  var CENTER_BOX_ROWS = 4, CENTER_BOX_MAX_ROW_PT = 28;
  function centerBoxOffsetPt(pointSize, centerBoxRows = CENTER_BOX_ROWS) {
    return Math.min(rowPitchPt(pointSize), CENTER_BOX_MAX_ROW_PT) * centerBoxRows / 2;
  }
  function centerOffset(boxOffset, blockHeight) {
    return Math.max(boxOffset, blockHeight / 2);
  }
  var CLASSIC_RATIO = 0.3333, TALL_MESSAGE_MIN_SET_LINES = 7, CLASSIC_MIN_GAP_IN = 0.25, CLASSIC_TOP_MIN_IN = 0.75;
  function isTallMessage(lines) {
    return lines.filter((l) => l.trim().length > 0).length >= TALL_MESSAGE_MIN_SET_LINES;
  }
  function classicLift(a) {
    if (!isTallMessage(a.lines) || Math.abs(a.placementRatio - CLASSIC_RATIO) > 1e-3) return 0;
    let perIn = a.cardH / a.cardHIn, sixGap = 0.5 * a.cardH - centerOffset(a.centerBoxOffset, 6 * a.rowH) - (a.placementRatio * a.cardH - a.rowH), gap = Math.max(sixGap, CLASSIC_MIN_GAP_IN * perIn), centeredTop = 0.5 * a.cardH - centerOffset(a.centerBoxOffset, a.blockH), classicTop = a.placementRatio * a.cardH - a.firstRowH, target = Math.max(CLASSIC_TOP_MIN_IN * perIn, Math.min(classicTop, centeredTop - gap));
    return Math.max(0, classicTop - target);
  }
  function centerOffsetPt(pointSize, blockHeightPt, centerBoxRows = CENTER_BOX_ROWS) {
    return centerOffset(centerBoxOffsetPt(pointSize, centerBoxRows), blockHeightPt);
  }
  function emulatorTransform(anchor, rowHpx, pxPerPt, blockHpx = 0, centerBoxRows = CENTER_BOX_ROWS, liftPx = 0) {
    return anchor === "baseline" ? `translate(-50%, -${rowHpx + liftPx}px)` : `translate(-50%, -${centerOffset(emulatorCenterBoxOffset(rowHpx, pxPerPt, centerBoxRows), blockHpx)}px)`;
  }
  function emulatorCenterBoxOffset(rowHpx, pxPerPt, centerBoxRows = CENTER_BOX_ROWS) {
    return Math.min(rowHpx, Math.ceil(CENTER_BOX_MAX_ROW_PT * pxPerPt)) * centerBoxRows / 2;
  }
  function trimTrailingEmpty(lines) {
    let last = -1;
    return lines.forEach((l, i) => {
      l.trim() && (last = i);
    }), lines.slice(0, last + 1);
  }
  function rowHeights(lines, halfSpaces, px, pointSize, lineSizesPt) {
    let half = new Set((halfSpaces != null ? halfSpaces : []).filter((i) => Number.isInteger(i) && i >= 0 && i < lines.length && lines[i].trim().length === 0)), row = px * lineHeight(pointSize), full = px * spaceEm(pointSize), halfH = px * spaceEm(pointSize, !0);
    return lines.map((l, i) => l.trim() ? rowOfSize(row, px, pointSize, lineSizePt(lineSizesPt, i, pointSize)) : half.has(i) ? halfH : full);
  }
  function lineSizePt(lineSizesPt, i, pointSize) {
    let s = lineSizesPt == null ? void 0 : lineSizesPt[i];
    return typeof s == "number" && Number.isFinite(s) && s > 0 ? s : pointSize;
  }
  function rowOfSize(row, px, pointSize, size) {
    return size === pointSize ? row : px * (size / pointSize) * lineHeight(size);
  }
  function rowGapExtras(lines, px, pointSize, lineSizesPt) {
    let scale = px / pointSize, prevSize = -1;
    return lines.map((l, i) => {
      if (!l.trim()) return 0;
      let size = lineSizePt(lineSizesPt, i, pointSize), extra = prevSize > 0 && size !== prevSize ? scale * Math.abs(size - prevSize) / 2 : 0;
      return prevSize = size, extra;
    });
  }
  function lineSizesOf(lines, pointSize, lineSizesPt) {
    return lines.map((_l, i) => lineSizePt(lineSizesPt, i, pointSize));
  }
  function pngLayout(dims, dpi, pointSize, placement, rawLines, halfSpaces, centerBoxRows = CENTER_BOX_ROWS, lineSizesPt) {
    var _a, _b;
    let width = Math.round(dims[0] * dpi), height = Math.round(dims[1] * dpi), px = pointSize * (dpi / 72), rowH = px * lineHeight(pointSize), lines = trimTrailingEmpty(rawLines), heights = rowHeights(lines, halfSpaces, px, pointSize, lineSizesPt), extras = rowGapExtras(lines, px, pointSize, lineSizesPt), blockH = heights.reduce((a, b) => a + b, 0) + extras.reduce((a, b) => a + b, 0), boxOffset = centerBoxOffsetPt(pointSize, centerBoxRows) * (dpi / 72), y0 = placement.anchor === "baseline" ? placement.verticalCenterRatio * height - ((_a = heights[0]) != null ? _a : rowH) - classicLift({
      lines,
      cardH: height,
      cardHIn: dims[1],
      cardWIn: dims[0],
      placementRatio: placement.verticalCenterRatio,
      firstRowH: (_b = heights[0]) != null ? _b : rowH,
      rowH,
      blockH,
      centerBoxOffset: boxOffset
    }) : placement.verticalCenterRatio * height - centerOffset(boxOffset, blockH), lineCenters = [], y = y0;
    heights.forEach((h, i) => {
      y += extras[i], lineCenters.push(y + h / 2), y += h;
    });
    let linePx = lineSizesOf(lines, pointSize, lineSizesPt).map((s) => s === pointSize ? px : s * (dpi / 72));
    return { width, height, px, rowH, y0, lines, rowHeights: heights, lineCenters, linePx, borderWidth: Math.max(1, Math.round(dpi / 120)) };
  }
  var BOTTOM_MARGIN_IN = 1;
  function typeFit(dims, pointSize, placement, rawLines, halfSpaces, centerBoxRows = CENTER_BOX_ROWS, lineSizesPt) {
    let L = pngLayout(dims, 72, pointSize, placement, rawLines, halfSpaces, centerBoxRows, lineSizesPt), first = -1, last = -1;
    if (L.lines.forEach((l, i) => {
      l.trim() && (first < 0 && (first = i), last = i);
    }), first < 0) return null;
    let top = L.lineCenters[first] - L.linePx[first] / 2, heightIn = (L.lineCenters[last] + L.linePx[last] / 2 - top) / 72, allowanceIn = dims[1] - BOTTOM_MARGIN_IN - top / 72;
    return { fits: heightIn <= allowanceIn + 1e-6, heightIn, allowanceIn };
  }

  // services/composer/core/envelope.ts
  var ENVELOPE_DIMS_IN = [7.25, 5.25], ENVELOPE_AXIS_X_IN = ENVELOPE_DIMS_IN[0] / 2, FLAP_POINT_DEPTH_IN = 3, FLAP_SIDE_DEPTH_IN = 0.32, ENVELOPE_TOP_LIMIT_IN = 5 / 16, FLAP_CLEARANCE_IN = 0.25, ENVELOPE_MAX_PT = 18, ASCENDER_EM = 0.75, DESCENDER_EM = 0.25, ENVELOPE_MAX_LINES = 10, ENVELOPE_MAX_SPACER_LINES = 5, ENVELOPE_LINE_MEASURE_PICA = (ENVELOPE_DIMS_IN[0] - 2 * FLAP_CLEARANCE_IN) * 6, EDGE_ANGLE = Math.atan((FLAP_POINT_DEPTH_IN - FLAP_SIDE_DEPTH_IN) / ENVELOPE_AXIS_X_IN), EDGE_INSET_IN = FLAP_CLEARANCE_IN / Math.sin(EDGE_ANGLE);
  function flapHalfWidthIn(depthIn) {
    return depthIn <= FLAP_SIDE_DEPTH_IN ? ENVELOPE_AXIS_X_IN : depthIn >= FLAP_POINT_DEPTH_IN ? 0 : ENVELOPE_AXIS_X_IN * (FLAP_POINT_DEPTH_IN - depthIn) / (FLAP_POINT_DEPTH_IN - FLAP_SIDE_DEPTH_IN);
  }
  function flapAllowanceIn(depthIn) {
    let sides = ENVELOPE_AXIS_X_IN - FLAP_CLEARANCE_IN, edges = depthIn <= FLAP_SIDE_DEPTH_IN ? sides : flapHalfWidthIn(depthIn) - EDGE_INSET_IN;
    return 2 * Math.min(sides, edges);
  }
  function flapMaxDepthIn(widthIn) {
    let half = widthIn / 2;
    if (half > ENVELOPE_AXIS_X_IN - FLAP_CLEARANCE_IN + 1e-9) return -1 / 0;
    let d = FLAP_POINT_DEPTH_IN - (half + EDGE_INSET_IN) * (FLAP_POINT_DEPTH_IN - FLAP_SIDE_DEPTH_IN) / ENVELOPE_AXIS_X_IN;
    return Math.max(d, FLAP_SIDE_DEPTH_IN);
  }
  function envelopeSizeOk(sizeLabel) {
    let n = parseInt(sizeLabel, 10);
    return Number.isFinite(n) && n > 0 && n <= ENVELOPE_MAX_PT;
  }
  function envelopeLayout(lines, halfSpaces, pointSize, sizesPt, widthsPica) {
    let drawn = trimTrailingEmpty(lines), sizes = lineSizesOf(drawn, pointSize, sizesPt), half = new Set(halfSpaces != null ? halfSpaces : []), out = [], baselinePt = null, prevSize = 0, pendingPt = 0;
    drawn.forEach((text, i) => {
      let blank = !text.trim();
      if (blank) {
        pendingPt += spacePt(pointSize, half.has(i)), out.push({ index: i, text, blank, sizePt: sizes[i], baselineIn: NaN, topIn: NaN, bottomIn: NaN, allowanceIn: 1 / 0 });
        return;
      }
      let s = sizes[i], b = baselinePt === null ? ENVELOPE_TOP_LIMIT_IN * 72 + pendingPt + ASCENDER_EM * s : baselinePt + LUDLOW_SLUG_BODY_PT + Math.max(s, prevSize) + pendingPt;
      baselinePt = b, prevSize = s, pendingPt = 0;
      let bottomIn = (b + DESCENDER_EM * s) / 72;
      out.push({ index: i, text, blank, sizePt: s, baselineIn: b / 72, topIn: (b - ASCENDER_EM * s) / 72, bottomIn, allowanceIn: flapAllowanceIn(bottomIn) });
    });
    let shift = widthsPica ? envelopeCentreShiftIn(out, widthsPica) : 0;
    return shift ? out.map((l) => l.blank ? l : __spreadProps(__spreadValues({}, l), { baselineIn: l.baselineIn + shift, topIn: l.topIn + shift, bottomIn: l.bottomIn + shift, allowanceIn: flapAllowanceIn(l.bottomIn + shift) })) : out;
  }
  function envelopeCentreShiftIn(hung, widthsPica) {
    var _a;
    let room = 1 / 0;
    for (let l of hung) {
      if (l.blank) continue;
      let w = Math.round(((_a = widthsPica[l.index]) != null ? _a : 0) * 100) / 100 / 6;
      room = Math.min(room, flapMaxDepthIn(w) - l.bottomIn);
    }
    return Number.isFinite(room) && room > 0 ? room / 2 : 0;
  }
  function flapIssues(lines, halfSpaces, pointSize, sizesPt, widthsPica) {
    return envelopeLayout(lines, halfSpaces, pointSize, sizesPt).filter((l) => {
      var _a;
      return !l.blank && (l.allowanceIn <= 0 || ((_a = widthsPica[l.index]) != null ? _a : 0) / 6 > l.allowanceIn + 1e-6);
    }).map((l) => {
      var _a;
      return { lineNum: l.index + 1, widthIn: ((_a = widthsPica[l.index]) != null ? _a : 0) / 6, allowanceIn: Math.max(0, l.allowanceIn) };
    });
  }

  // services/composer/core/limits.ts
  var CARD_LINE_MEASURE_PICA = { portrait: 24, landscape: 33 }, MAX_SLUGS_PER_LINE = 2, WHITE_GLOVE_MAX_LINES = 20, WHITE_GLOVE_MAX_SPACER_LINES = 10, WHITE_GLOVE_LEGACY_MAX_LINES = 6, WHITE_GLOVE_LEGACY_MAX_SPACER_LINES = 2, FLAT_MAX_LINES = 20, FLAT_MAX_SPACER_LINES = 10;
  function spacerLineAllowance(tier, maxLines = 0) {
    return tier === "white-glove" ? WHITE_GLOVE_MAX_SPACER_LINES : tier === "flat" ? FLAT_MAX_SPACER_LINES : tier === "envelope" ? ENVELOPE_MAX_SPACER_LINES : Math.max(0, maxLines - 1);
  }
  function tierMaxLines(catalog, tier) {
    return tier === "white-glove" ? WHITE_GLOVE_MAX_LINES : tier === "flat" ? FLAT_MAX_LINES : tier === "envelope" ? ENVELOPE_MAX_LINES : catalog.maxLines;
  }
  function setLineCount(lines) {
    return lines.filter((l) => l.trim().length > 0).length;
  }
  function lineCaps(lim) {
    return { maxSet: lim.maxLines, maxTotal: lim.maxLines + spacerLineAllowance(lim.tier, lim.maxLines) };
  }
  function leadingBlankCount(lines) {
    let first = lines.findIndex((l) => l.trim().length > 0);
    return first < 0 ? 0 : first;
  }
  function storefrontSpacesValid(lines) {
    let last = -1;
    lines.forEach((l, i) => {
      l.trim() && (last = i);
    });
    for (let i = leadingBlankCount(lines) + 1; i < last; i++)
      if (!lines[i].trim() && !lines[i - 1].trim()) return !1;
    return !0;
  }
  function withinLineCaps(lines, lim) {
    let caps = lineCaps(lim);
    return lines.length > caps.maxTotal ? !1 : setLineCount(lines) + (lim.tier === "storefront" ? leadingBlankCount(lines) : 0) <= caps.maxSet;
  }
  function cardLineMeasurePica(catalog, format) {
    var _a, _b;
    return (_b = (_a = catalog.cardLineMeasurePica) == null ? void 0 : _a[format]) != null ? _b : CARD_LINE_MEASURE_PICA[format];
  }
  function composeLimits(catalog, face, format, tier = "storefront") {
    let bedPica = faceLimitPica(catalog, face), maxSlugs = MAX_SLUGS_PER_LINE, limitPica = Math.min(tier === "envelope" ? ENVELOPE_LINE_MEASURE_PICA : cardLineMeasurePica(catalog, format), bedPica * maxSlugs);
    return {
      tier,
      maxLines: tierMaxLines(catalog, tier),
      limitPica,
      bedPica,
      maxSlugs
    };
  }
  function lineCharCap(size, limits) {
    return size.maxCharsPerLine > 0 ? size.maxCharsPerLine * limits.maxSlugs : 0;
  }
  function marginBinds(lines, tier) {
    if (tier === "envelope") return !1;
    if (tier !== "white-glove") return !0;
    let trimmed = [...lines];
    for (; trimmed.length && !trimmed[trimmed.length - 1].trim(); ) trimmed.pop();
    return setLineCount(trimmed) > WHITE_GLOVE_LEGACY_MAX_LINES || trimmed.length > WHITE_GLOVE_LEGACY_MAX_LINES + WHITE_GLOVE_LEGACY_MAX_SPACER_LINES;
  }

  // services/composer/core/splice.ts
  function firstOverIndex(text, font, limitPx, measurer) {
    for (let i = 1; i <= text.length; i++)
      if (measurer.widthPx(text.slice(0, i), font) > limitPx) return i - 1;
    return text.length;
  }
  function spliceLine(text, font, bedPica, maxSlugs, measurer) {
    let bedPx = bedPica * PX_PER_PICA, widthPica = measurer.widthPx(text, font) / PX_PER_PICA, slugs = [], start = 0, overKind = null, overFromIndex = -1;
    for (; start < text.length || slugs.length === 0; ) {
      let rest = text.slice(start), restPx = measurer.widthPx(rest, font);
      if (restPx <= bedPx) {
        slugs.push({ text: rest, start, end: text.length, widthPica: restPx / PX_PER_PICA, over: !1 });
        break;
      }
      let fit = firstOverIndex(rest, font, bedPx, measurer);
      if (slugs.length === Math.max(1, maxSlugs) - 1) {
        overKind = "slugs", overFromIndex = start + fit, slugs.push({ text: rest, start, end: text.length, widthPica: restPx / PX_PER_PICA, over: !0 });
        break;
      }
      let cut = -1;
      for (let i = fit; i > 0; i--)
        if (rest[i] === " ") {
          cut = i;
          break;
        }
      let gapStart = cut;
      for (; gapStart > 0 && rest[gapStart - 1] === " "; ) gapStart--;
      if (cut <= 0 || rest.slice(0, gapStart).trim() === "") {
        overKind = "word", overFromIndex = start + fit, slugs.push({ text: rest, start, end: text.length, widthPica: restPx / PX_PER_PICA, over: !0 });
        break;
      }
      let gapEnd = cut;
      for (; gapEnd < rest.length && rest[gapEnd] === " "; ) gapEnd++;
      let head = rest.slice(0, gapStart);
      slugs.push({ text: head, start, end: start + gapStart, widthPica: measurer.widthPx(head, font) / PX_PER_PICA, over: !1 }), start += gapEnd;
    }
    return { slugs, widthPica, over: overKind !== null, overKind, overFromIndex };
  }
  function unbreakableWord(text, fromIndex) {
    let s = fromIndex;
    for (; s > 0 && text[s - 1] !== " "; ) s--;
    let e = fromIndex;
    for (; e < text.length && text[e] !== " "; ) e++;
    return text.slice(s, e);
  }

  // services/composer/core/inventory.ts
  function validateLine(text, inventory) {
    var _a, _b;
    let running = /* @__PURE__ */ new Map(), badIndexes = /* @__PURE__ */ new Set();
    for (let i = 0; i < text.length; i++) {
      let ch = text[i], used = ((_a = running.get(ch)) != null ? _a : 0) + 1;
      running.set(ch, used);
      let avail = (_b = inventory[ch]) != null ? _b : 0;
      used > avail && badIndexes.add(i);
    }
    let overages = [];
    return running.forEach((used, ch) => {
      var _a2;
      let avail = (_a2 = inventory[ch]) != null ? _a2 : 0;
      used > avail && overages.push({ char: ch, used, avail });
    }), { overages, badIndexes };
  }

  // services/composer/core/inks.ts
  var SPECIAL_INKS = {
    black: { id: "black", name: "Black", hex: "#1A1A1A" }
  }, INK_ID_RE = /^[a-z0-9-]{1,32}$/, CUSTOM_INK_RE = /^pms:([0-9a-f]{6}):([A-Za-z0-9][A-Za-z0-9 .+\-/]{0,39})$/;
  function parseCustomInk(ink) {
    let m = typeof ink == "string" ? CUSTOM_INK_RE.exec(ink) : null;
    return m ? { hex: `#${m[1].toUpperCase()}`, name: m[2] } : null;
  }
  function inkValid(ink) {
    return ink == null || parseCustomInk(ink) ? !0 : typeof ink == "string" && INK_ID_RE.test(ink) && Object.prototype.hasOwnProperty.call(SPECIAL_INKS, ink);
  }

  // services/composer/core/styles.ts
  function isBlank(line) {
    return (line != null ? line : "").trim().length === 0;
  }
  function isSet(s) {
    return !!s && (s.face !== void 0 || s.size !== void 0);
  }
  function lineStyleAt(c, i) {
    var _a, _b, _c;
    let s = (_a = c.lineStyles) == null ? void 0 : _a[i];
    return { face: (_b = s == null ? void 0 : s.face) != null ? _b : c.face, size: (_c = s == null ? void 0 : s.size) != null ? _c : c.size };
  }
  function lineStylesValid(lines, lineStyles) {
    return lineStyles != null && lineStyles.length ? lineStyles.length > lines.length ? !1 : lineStyles.every((s, i) => s ? s.face !== void 0 && (typeof s.face != "string" || !s.face) || s.size !== void 0 && (typeof s.size != "string" || !s.size) ? !1 : !isSet(s) || !isBlank(lines[i]) : !0) : !0;
  }
  function normalizeLineStyles(c) {
    var _a;
    let out = ((_a = c.lineStyles) != null ? _a : []).slice(0, c.lines.length).map((s) => {
      if (!s) return null;
      let n = {};
      return s.face !== void 0 && s.face !== c.face && (n.face = s.face), s.size !== void 0 && s.size !== c.size && (n.size = s.size), isSet(n) ? n : null;
    });
    for (; out.length && out[out.length - 1] === null; ) out.pop();
    return out;
  }
  function hasLineStyles(c) {
    return normalizeLineStyles(c).length > 0;
  }
  function lineSizesPtOf(c) {
    let styles = normalizeLineStyles(c);
    if (styles.some((s) => (s == null ? void 0 : s.size) !== void 0))
      return c.lines.map((l, i) => {
        var _a;
        return isBlank(l) || ((_a = styles[i]) == null ? void 0 : _a.size) === void 0 ? null : sizePt(styles[i].size);
      });
  }
  function resolveStyle(catalog, style) {
    let face = catalog.faces[style.face];
    return face ? face.webFont ? face.sizes[style.size] ? { ok: !0, face } : { ok: !1, reason: "unknown_size" } : { ok: !1, reason: "no_web_font" } : { ok: !1, reason: "unknown_face" };
  }
  function lineStylesKey(c) {
    let styles = normalizeLineStyles(c);
    return styles.length ? "styles:" + styles.map((s, i) => {
      var _a, _b;
      return s ? `${i}=${(_a = s.face) != null ? _a : ""}/${(_b = s.size) != null ? _b : ""}` : "";
    }).filter(Boolean).join(";") : "";
  }

  // services/composer/core/validate.ts
  function normalizeHalfSpaces(lines, halfSpaces) {
    return halfSpaces != null && halfSpaces.length ? [...new Set(halfSpaces)].filter((i) => Number.isInteger(i) && i >= 0 && i < lines.length && lines[i].trim().length === 0).sort((a, b) => a - b) : [];
  }
  function halfSpacesValid(lines, halfSpaces) {
    return halfSpaces != null && halfSpaces.length ? halfSpaces.every((i) => Number.isInteger(i) && i >= 0 && i < lines.length && lines[i].trim().length === 0) : !0;
  }
  function failed(reason, lim, styleLineNum) {
    return __spreadValues({
      ok: !1,
      reason,
      inventoryIssues: [],
      measureIssues: [],
      lines: [],
      measures: [],
      limitPica: lim.limitPica,
      bedPica: lim.bedPica,
      font: ""
    }, styleLineNum ? { styleLineNum } : {});
  }
  function badStyleLineNum(c) {
    var _a;
    let styles = (_a = c.lineStyles) != null ? _a : [];
    if (styles.length > c.lines.length) return;
    let i = styles.findIndex((_s, k) => !lineStylesValid(c.lines, styles.slice(0, k + 1)));
    return i >= 0 ? i + 1 : void 0;
  }
  function validateComposition(c, catalog, measurer, limits) {
    let lim = limits != null ? limits : composeLimits(catalog, c.face, c.format, "storefront"), limitPica = lim.limitPica, face = catalog.faces[c.face];
    if (!face) return failed("unknown_face", lim);
    if (!face.webFont) return failed("no_web_font", lim);
    let cfg = face.sizes[c.size];
    if (!cfg) return failed("unknown_size", lim);
    if (!withinLineCaps(c.lines, lim)) return failed("too_many_lines", lim);
    if (!halfSpacesValid(c.lines, c.halfSpaces) || lim.tier === "storefront" && !storefrontSpacesValid(c.lines)) return failed("bad_line_space", lim);
    if (!lineStylesValid(c.lines, c.lineStyles)) return failed("bad_line_style", lim, badStyleLineNum(c));
    if (lim.tier === "storefront" && hasLineStyles(c)) return failed("bad_line_style", lim);
    if (!inkValid(c.ink) || lim.tier === "storefront" && c.ink !== void 0 && c.ink !== null) return failed("bad_ink", lim);
    if (lim.tier === "envelope") {
      if (!envelopeSizeOk(c.size)) return failed("unknown_size", lim);
      let over = c.lines.findIndex((l, i) => l.trim() && !envelopeSizeOk(lineStyleAt(c, i).size));
      if (over >= 0) return failed("unknown_size", lim, over + 1);
    }
    let font = measureFontSpec(face.webFont, c.size), settings = [];
    for (let idx = 0; idx < c.lines.length; idx++) {
      let st = lineStyleAt(c, idx);
      if (!c.lines[idx].trim() || st.face === c.face && st.size === c.size) {
        settings.push({ font, lim, inventory: cfg.inventory });
        continue;
      }
      let r = resolveStyle(catalog, st);
      if (!r.ok) return failed(r.reason, lim, idx + 1);
      let lineLim = st.face === c.face ? lim : composeLimits(catalog, st.face, c.format, lim.tier), lineFont = measureFontSpec(r.face.webFont, st.size);
      settings.push({
        font: lineFont,
        lim: lineLim,
        inventory: r.face.sizes[st.size].inventory,
        style: { face: st.face, size: st.size, font: lineFont, limitPica: lineLim.limitPica, bedPica: lineLim.bedPica }
      });
    }
    let inventoryIssues = [], measureIssues = [], lines = [], measures = [];
    if (c.lines.forEach((text, idx) => {
      let lineNum = idx + 1, badIndexes = /* @__PURE__ */ new Set(), set = settings[idx], lineLimitPica = set.lim.limitPica, m = measureLine(text, set.font, lineLimitPica, measurer);
      if (measures.push(m.widthPica), m.overFromIndex >= 0) for (let i = m.overFromIndex; i < text.length; i++) badIndexes.add(i);
      m.over && measureIssues.push({ lineNum, kind: "card", widthPica: m.widthPica, limitPica: lineLimitPica });
      let sp = spliceLine(text, set.font, set.lim.bedPica, set.lim.maxSlugs, measurer);
      if (sp.over && !m.over) {
        for (let i = sp.overFromIndex; i < text.length; i++) badIndexes.add(i);
        let issue = { lineNum, kind: sp.overKind === "word" ? "word" : "slugs", widthPica: sp.widthPica, limitPica: set.lim.bedPica };
        issue.kind === "word" && (issue.word = unbreakableWord(text, sp.overFromIndex)), measureIssues.push(issue);
      }
      sp.slugs.forEach((slug, s) => {
        let inv = validateLine(slug.text, set.inventory);
        inv.badIndexes.forEach((i) => badIndexes.add(slug.start + i));
        for (let o of inv.overages) inventoryIssues.push({ lineNum, char: o.char, used: o.used, avail: o.avail, slug: s + 1, slugCount: sp.slugs.length });
      }), lines.push(__spreadValues({ text, widthPica: m.widthPica, slugs: sp.slugs, badIndexes }, set.style ? { style: set.style } : {}));
    }), lim.tier === "envelope")
      for (let f of flapIssues(c.lines, c.halfSpaces, sizePt(c.size), lineSizesPtOf(c), measures)) {
        if (measureIssues.some((m) => m.lineNum === f.lineNum)) continue;
        measureIssues.push({ lineNum: f.lineNum, kind: "flap", widthPica: f.widthIn * 6, limitPica: f.allowanceIn * 6 });
        let rep = lines[f.lineNum - 1];
        for (let i = 0; i < rep.text.length; i++) rep.badIndexes.add(i);
      }
    let hasErrors = inventoryIssues.length > 0 || measureIssues.length > 0, nonEmpty = c.lines.some((l) => l.trim().length > 0), fit = fitOf(c, catalog), tooTall = !!fit && !fit.fits && marginBinds(c.lines, lim.tier);
    return { ok: !hasErrors && nonEmpty && !tooTall, reason: hasErrors ? "inventory" : nonEmpty ? tooTall ? "too_tall" : null : "incomplete", inventoryIssues, measureIssues, lines, measures, limitPica, bedPica: lim.bedPica, font, fit };
  }
  function hasLineSpace(lines) {
    let first = lines.findIndex((l) => l.trim().length > 0), last = -1;
    lines.forEach((l, i) => {
      l.trim() && (last = i);
    });
    for (let i = first + 1; i < last; i++) if (!lines[i].trim()) return !0;
    return !1;
  }
  function fitOf(c, catalog) {
    return placementKnown(catalog, c.placement, !0) ? typeFit(cardDims(catalog, c.format), sizePt(c.size), placementOption(catalog, c.placement), c.lines, c.halfSpaces, CENTER_BOX_ROWS, lineSizesPtOf(c)) : null;
  }
  function describeFit(fit) {
    let d = fit.heightIn.toFixed(1) === fit.allowanceIn.toFixed(1) ? 2 : 1;
    return `Message \u2014 ${fit.heightIn.toFixed(d)}\u2033 tall of ${fit.allowanceIn.toFixed(d)}\u2033 \u2014 remove a line or a space, or choose a smaller size`;
  }
  function inchesLabel(pica) {
    return (pica / 6).toFixed(2);
  }
  function statusTitle(r) {
    return r.inventoryIssues.length && r.measureIssues.length ? "Message Adjustments Needed" : r.inventoryIssues.length ? "Type Inventory Issue" : r.measureIssues.length ? "Line Too Long" : r.reason === "too_many_lines" ? "Too Many Lines" : r.reason === "bad_line_space" ? "Line Space Misplaced" : r.reason === "too_tall" ? "Message Too Tall" : r.reason === "bad_line_style" ? "Line Style Not Allowed" : r.reason === "bad_ink" ? "Ink Not Available" : r.styleLineNum ? "Line Style Not Available" : null;
  }
  function describeInventoryIssue(o) {
    let dc = o.char === " " ? "Space" : `\u201C${o.char}\u201D`;
    return `${o.slugCount > 1 ? `Line ${o.lineNum}, part ${o.slug} of ${o.slugCount}` : `Line ${o.lineNum}`}: ${dc} used ${o.used}\xD7 but only ${o.avail} available (${o.used - o.avail} too many)`;
  }
  function describeMeasureIssue(o) {
    var _a;
    switch (o.kind) {
      case "flap":
        return o.limitPica <= 0 ? `Line ${o.lineNum} falls below the flap's point \u2014 remove a line or a space, or choose smaller type.` : `Line ${o.lineNum} runs ${inchesLabel(o.widthPica)}\u2033 \u2014 the flap fits ${inchesLabel(o.limitPica)}\u2033 at that depth, \xBC\u2033 clear of its edges. Shorten it, or choose smaller type.`;
      case "card":
        return `Line ${o.lineNum} runs ${inchesLabel(o.widthPica)}\u2033 \u2014 the card fits ${inchesLabel(o.limitPica)}\u2033 per line. Shorten it to fit.`;
      case "word":
        return `Line ${o.lineNum}: \u201C${(_a = o.word) != null ? _a : ""}\u201D is too long for this typeface \u2014 a single word fits ${inchesLabel(o.limitPica)}\u2033. Shorten it or add a space.`;
      case "slugs":
        return `Line ${o.lineNum} can't break where it needs to \u2014 this typeface sets ${inchesLabel(o.limitPica)}\u2033 at a stretch. Move a word to the next line or shorten it.`;
    }
  }
  var KEY_SEP = "";
  function compositionKey(c) {
    let hs = normalizeHalfSpaces(c.lines, c.halfSpaces), st = lineStylesKey(c);
    return [c.face, c.size, c.placement, c.format, ...c.lines, ...hs.length ? [`half:${hs.join(",")}`] : [], ...st ? [st] : [], ...c.ink ? [`ink:${c.ink}`] : []].join(KEY_SEP);
  }

  // services/composer/core/proof.ts
  function buildProofPayload(a) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!a.validation.ok) throw new Error(`cannot build a proof from an invalid composition (${a.validation.reason})`);
    let face = a.catalog.faces[a.composition.face];
    if (!(face != null && face.webFont)) throw new Error(`face ${JSON.stringify(a.composition.face)} is unknown or not web-renderable`);
    let halfSpaces = normalizeHalfSpaces(a.composition.lines, a.composition.halfSpaces), lineStyles = normalizeLineStyles(a.composition), lineMeasuredWith = lineStyles.map((s, i) => {
      var _a2;
      if (!s) return null;
      let wf = (_a2 = a.catalog.faces[lineStyleAt(a.composition, i).face]) == null ? void 0 : _a2.webFont;
      if (!wf) throw new Error(`line ${i + 1}'s face is unknown or not web-renderable`);
      return __spreadValues({}, wf);
    });
    return __spreadProps(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadProps(__spreadValues({
      catalogVersion: a.catalog.catalogVersion,
      face: a.composition.face,
      size: a.composition.size,
      placement: a.composition.placement,
      format: a.composition.format,
      lines: [...a.composition.lines]
    }, halfSpaces.length ? { halfSpaces } : {}), {
      lineWidthsPica: a.validation.measures.map((w) => Math.round(w * 100) / 100),
      limitPica: ((_a = a.limits) != null ? _a : composeLimits(a.catalog, a.composition.face, a.composition.format)).limitPica,
      bedPica: a.validation.bedPica,
      lineSlugs: a.validation.lines.map((l) => l.slugs.map((s) => ({ text: s.text, widthPica: Math.round(s.widthPica * 100) / 100 })))
    }), a.limits && a.limits.tier !== "storefront" ? { tier: a.limits.tier } : {}), {
      measuredWith: __spreadValues({}, face.webFont)
    }), lineStyles.length ? { lineStyles, lineMeasuredWith } : {}), a.composition.ink ? { ink: a.composition.ink } : {}), {
      visitorId: (_b = a.visitorId) != null ? _b : null,
      sessionId: (_c = a.sessionId) != null ? _c : null,
      product: { handle: (_e = (_d = a.product) == null ? void 0 : _d.handle) != null ? _e : null, variantId: (_g = (_f = a.product) == null ? void 0 : _f.variantId) != null ? _g : null }
    });
  }
  return __toCommonJS(browser_exports);
})();
